/* eslint-disable no-use-before-define */
import axios from 'services/axios.wrapper';
import config from 'services/config';

const { apiServer } = config;
const supplierListUrl = `${apiServer}/v1/iam/supplier/supplierdropdown`;
const switchToSupplierUrl = `${apiServer}/v1/iam/sc-sso/getssolink`;
const switchToCclpAccountUrl = `${apiServer}/v1/iam/switchcclpaccounts`;

export default {
  getSupplierDropDownList,
  switchAccounts
};

function getSupplierDropDownList() {
  const promise = axios.get(supplierListUrl);
  promise.catch(error => console.error(error));
  return promise;
}

function switchAccounts(supplierDropdownItem) {
  switch (supplierDropdownItem.SupplierDropdownType) {
    case 'Supplier':
      return switchToSupplier(supplierDropdownItem);
    case 'CclpAccount':
      return switchToCclpAccount(supplierDropdownItem);
    default:
      return Promise.reject(new Error('Invalid SupplierDropdownType'));
  }
}

function switchToSupplier(supplierDropdownItem) {
  return axios.post(switchToSupplierUrl, { SupplierId: supplierDropdownItem.SupplierId, ReturnUrl: window.location.href });
}

function switchToCclpAccount(supplierDropdownItem) {
  return axios.post(switchToCclpAccountUrl, { CclpAccountUid: supplierDropdownItem.Guid });
}
